import { Layout } from 'antd';
import classNames from 'classnames';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../../global-context/GlobalContext';
import { useEffectOnce } from '../../../hooks/utils/useEffectOnce';
import useIsMobile from '../../../hooks/utils/useIsMobile';
import { AppRouter } from '../../../routes/AppRouter';
import routes from '../../../routes/Routes';
import { tokenService } from '../../../services/TokenService';
import { AccessContext } from '../../../store/access/AccessContext';
import { setNavigateFunction } from '../../../utils/commonUtility';
import Header from '../../header/Header';
import { MainNavigation } from '../main-navigation/MainNavigation';
import './LayoutComponent.scss';

const { Content } = Layout;

function LayoutComponent() {
  const access = useContext(AccessContext);
  const globalIsSignedIn = useGlobalContext(c => c.auth.isAuthenticated);
  const isSidePanelOpen = useGlobalContext(c => c.app.isSidePanelOpen);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const hasToken = Boolean(tokenService.getToken());
  const isSignedIn = hasToken || globalIsSignedIn || Boolean(access?.menuGuardEnabled && access?.status === 'ready');

  useEffectOnce(() => {
    setNavigateFunction(navigate);
  });

  return (
    <Layout className='main-layout' hasSider>
      <Header isSignedIn={isSignedIn} />
      <MainNavigation isSignedIn={isSignedIn} />
      <Content
        className={classNames('content-container', {
          'is-login': isSignedIn,
          'sidebar-open': isSignedIn && !isMobile && isSidePanelOpen,
          mobile: isMobile,
        })}
      >
        <AppRouter routes={routes} />
      </Content>
    </Layout>
  );
}

export default LayoutComponent;
